import React, { ComponentType, useState } from 'react';
import styled from 'styled-components';
import { Flexer } from '../../app/dashboard/elements/LayoutElements';
import { toRem } from '../../ui';

export type SebComponent = ComponentType<{ active?: boolean, size?: number }>;

export const SebWithHover = ({ seb: Seb, size }: { seb: SebComponent, size?: number }) => {
    const [active, setActive] = useState(0);
    const onEnter = () => setActive(x => x + 1);
    const onLeave = () => setActive(0);
    return <Flexer width={size || 4} height={size || 4} onMouseMove={onEnter} onMouseLeave={onLeave}>
        <Seb active={active > 0} size={size} />
    </Flexer>;
};

export const SebMount = styled.div<{ size?: number }>`
    position: relative;
    width: ${p => toRem(p.size || 4)};
    height: ${p => toRem(p.size || 4)};

    svg {
        position: absolute;
        top: -35%;
        left: 5%;
        width: 100%;
        pointer-events: none;
    }

    svg.wide {
        width: 118%;
        left: -13%;
    }
`;
